// extracted by mini-css-extract-plugin
module.exports = {"container":"pinningWrapper__container___1gohp","wrapper":"pinningWrapper__wrapper___3hxUD","header":"pinningWrapper__header___2UBJs"};